/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SurveyJobDefinitionYoyStatus {
    NEW = 'NEW',
    REVISED = 'REVISED',
}
